import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded'
import RadioButtonUncheckedRoundedIcon from '@mui/icons-material/RadioButtonUncheckedRounded'

import { UI_COLOR_DANGER_TEXT, UI_COLOR_SUCCESS_TEXT } from '../../../../constants/uiColors'

export default function ProfileSecurityPasswordRequirement({ isMet, label }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {isMet ? (
        <CheckCircleOutlineRoundedIcon sx={{ fontSize: 18, color: UI_COLOR_SUCCESS_TEXT }} />
      ) : (
        <RadioButtonUncheckedRoundedIcon sx={{ fontSize: 18, color: UI_COLOR_DANGER_TEXT }} />
      )}
      <Typography
        sx={{
          fontSize: 13.5,
          lineHeight: 1.4,
          color: isMet ? UI_COLOR_SUCCESS_TEXT : UI_COLOR_DANGER_TEXT
        }}
      >
        {label}
      </Typography>
    </Box>
  )
}
